import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import './assets/css/element-variables.scss';
import empty from './directives/empty';
import tween from './utils/tween'
import { post, get, upload, postReqestBody, download } from './utils/http'
import './utils/directiveAuth';
import './utils/Injection';
import './assets/css/index.scss'
import * as echarts from 'echarts'
import { parseTime, resetForm, changeInput,formatTimestamp } from "@/utils/common";
import './utils/rem'
Vue.use(ElementUI);
Vue.use(empty)
Vue.use(tween)
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$upload = upload;
Vue.prototype.$postReqestBody = postReqestBody;
Vue.prototype.$download = download;
Vue.prototype.$echarts = echarts;
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.changeInput = changeInput
Vue.prototype.formatTimestamp = formatTimestamp

ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
